import React, { useState, useEffect } from "react";
import { Box } from "fds";
import "./index.scss";
import { useNavigate, useParams } from "react-router-dom";
import useLoginStore from "../../redux/dispatcher/useLoginStore";
import Progress from "../Prgress";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { Workgroup } from "../../types/workgroup";
import Login from "../Login";
import Signup from "../Signup";
import WorkgroupAddModal from "../../components/WorkgroupAddModal";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import utilsCommon from "../../shared/utils/common";
import MailSuccess from "../Signup/MailSuccess";
import NewWebusingLink from "./ExtraAction/NewWebusingLink";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";

const UidLink = ({
  changeLoading,
}: {
  changeLoading: (status: boolean) => void;
}) => {
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const myId = loginDto?.userInfo?.userId ?? "";

  const navigate = useNavigate();
  const { uid } = useParams<{ uid: string }>();
  const { loginState, getInformationFromUid, getLogInByUid } = useLoginStore();
  const {
    documentState,
    getUploadDocsProgress,
    changeDocUploadUidCreate,
    getContentList,
  } = useDocumentStore();
  const { getWorkgroupSideList } = useWorkgroupStore();
  const [isAllowIp, setAllowIp] = useState<boolean | undefined>();
  const [actionInfo, changeActionInfo] = useState("");

  useEffect(() => {
    if (!uid) return;
    getInformationFromUid(uid).then((result: any) => {
      if (result.error) {
        setAllowIp(false);
        switch (result.error.name) {
          case "NOT_ALLOW_IP":
            navigate(`${process.env.PUBLIC_URL}/error?errorCode=NOT_ALLOW_IP`);
            break;
          case "INVALID_TENANCY":
            navigate(
              `${process.env.PUBLIC_URL}/error?errorCode=INVALID_TENANCY`
            );
            break;
          case "NOT_FOUND_USER":
            navigate(
              `${process.env.PUBLIC_URL}/error?errorCode=NOT_FOUND_USER`
            );
            break;
          case "NOT_FOUND_DATA":
            navigate(`${process.env.PUBLIC_URL}/error?errorCode=CLIENT_ERROR`);
            break;
          default:
            break;
        }
        return;
      } else {
        setAllowIp(true);
        // setDownloadStatus("");
      }
    });
  }, [uid]);
  useEffect(() => {
    const getFileInfoFromUid = async () => {
      await getLogInByUid(loginState.actionInfo.uniqueId);
      if (loginState.actionInfo.uploadUid) {
        getUploadDocsProgress(loginState.actionInfo.uploadUid);
      }
    };
    if (!isAllowIp || !loginState.actionInfo) return;
    changeActionInfo(loginState.actionInfo.urlAction);
    /** 링크 만료 */
    if (loginState.actionInfo && loginState.actionInfo.urlAction === "FAIL") {
      navigate(`${process.env.PUBLIC_URL}/error?errorCode=CLIENT_ERROR`);
      return;
    }
    if (
      [
        "REDIRECT_AGENT_MAIN",
        "REDIRECT_DOC_DETAIL_V2",
        "REDIRECT_DOC_DETAIL",
        "REDIRECT_FILE_SEND",
        "REDIRECT_FILE_SHARE",
        "REDIRECT_CREATE_WORKGROUP",
        "REDIRECT_MAIN",
        "REDIRECT_WORKGROUP_MEETING",
        "REDIRECT_WORKGROUP_LOG",
        "REDIRECT_WORKGROUP",
      ].includes(loginState.actionInfo.urlAction)
    ) {
      getFileInfoFromUid();
      return;
    }
  }, [loginState.actionInfo, isAllowIp, window.location.href]);
  useEffect(() => {
    const checkFilesExist = async () => {
      const receivedFiles: any = await getContentList({
        page: 0,
        size: 1,
        order: "datedesc",
        search: "",
        readType: "",
        masterUserId: "-1",
        tagCodes: ["NONEWORKGROUP"],
        date: {
          start: 0,
          end: 0,
        },
        folderCode: "",
      });
      const sendFiles: any = await getContentList({
        page: 0,
        size: 1,
        order: "datedesc",
        search: "",
        readType: "",
        masterUserId: myId,
        tagCodes: ["NONEWORKGROUP"],
        date: {
          start: 0,
          end: 0,
        },
        folderCode: "",
      });
      let workgroupList: any;
      if (loginDto?.ecoSystemLicenseStats?.featureAccessType !== "LITE")
        workgroupList = await getWorkgroupSideList({
          isDetail: "Y",
          managerId: "",
          orderBy: "workgroupName",
          orderByType: "ASC",
          pageRange: 1,
          posPage: 1,
          rowRange: 0,
          searchDate: { start: 0, end: 0 },
          status: 1,
          workgroupName: "",
        });
      const validCount =
        receivedFiles.payload?.docs?.count +
        sendFiles.payload?.docs?.count +
        (loginDto?.ecoSystemLicenseStats?.featureAccessType === "LITE"
          ? 0
          : workgroupList.payload.workgroupList?.filter(
              (item: Workgroup) => item.isValidate === 1
            ).length);
      navigate(
        validCount > 0
          ? `${process.env.PUBLIC_URL}/client/myBox`
          : `${process.env.PUBLIC_URL}/client/none`
      );
    };
    if (!loginState.loginInfo || !loginState?.actionInfo?.urlAction) return;
    switch (loginState.actionInfo.urlAction) {
      case "REDIRECT_AGENT_MAIN":
        checkFilesExist();
        break;
      case "REDIRECT_FILE_SEND":
      case "REDIRECT_FILE_SHARE":
        changeDocUploadUidCreate(loginState.actionInfo?.uploadUid);
        break;
      case "REDIRECT_MAIN":
        navigate(
          utilsCommon.renderProperNavigatePath(
            loginDto?.ecoSystemLicenseStats?.featureAccessType === "LITE"
              ? `${process.env.PUBLIC_URL}/myInbox/received`
              : `/home`
          )
        );
        break;
      case "REDIRECT_WORKGROUP_MEETING":
        navigate(
          utilsCommon.renderProperNavigatePath(
            `/workgroup/${loginState.actionInfo.workgroupId}/meeting?subTab=CREATE&from=UidLink`
          )
        );
        break;
      case "REDIRECT_WORKGROUP_LOG":
        navigate(
          utilsCommon.renderProperNavigatePath(
            `/workgroup/${loginState.actionInfo.workgroupId}/log?givenShowType=COMPRESS`
          )
        );
        break;
      case "REDIRECT_WORKGROUP":
        navigate(
          utilsCommon.renderProperNavigatePath(
            `/workgroup/${loginState.actionInfo.workgroupId}`
          )
        );
        break;
      case "REDIRECT_DOC_DETAIL":
      case "REDIRECT_DOC_DETAIL_V2":
        navigate(
          `${process.env.PUBLIC_URL}/client/docDetail/${loginState.actionInfo.syncId}`
        );
        break;
    }
  }, [loginState.loginInfo]);

  const renderProperPage = () => {
    switch (actionInfo) {
      case "WEBUSING":
      case "DOWNLOAD":
      case "WEBUSING_AND_DOWNLOAD":
      case "HTMLDOWNLOAD":
        return <NewWebusingLink />;
      case "REDIRECT_AGENT_MAIN":
      case "REDIRECT_AGENT_MAIN_WORKGROUP":
      case "REDIRECT_WORKGROUP":
      case "REDIRECT_WORKGROUP_MEETING":
      case "REDIRECT_WORKGROUP_LOG":
      case "REDIRECT_MAIN":
      case "REDIRECT_DOC_DETAIL":
      case "REDIRECT_DOC_DETAIL_V2":
        return <Progress inProgress />;
      case "JOIN_US":
        return <Signup actionInfo={loginState.actionInfo} />;
      case "MAIL_VERIFY":
        return <MailSuccess actionInfo={loginState.actionInfo} />;
      case "REDIRECT_FILE_SHARE":
      case "REDIRECT_FILE_SEND":
      case "REDIRECT_CREATE_WORKGROUP":
        return (
          <WorkgroupAddModal
            createType={
              actionInfo === "REDIRECT_FILE_SHARE"
                ? "SHARE_TO_WORKGROUP"
                : actionInfo === "REDIRECT_FILE_SEND"
                ? "SEND_FILE"
                : "CREATE_NEW_WORKGROUP"
            }
            open
            clientUid={loginState.actionInfo.uploadUid}
            receivedFiles={documentState.uploadDocsProgress?.uploadFiles}
            targetType="client"
            onClose={() => console.log("?")}
          />
        );
      case "PASSWORD_INIT":
        return <Login changeLoading={changeLoading} type="PASSWORD_INIT" />;
      default:
        return <Box>{actionInfo}</Box>;
    }
  };
  return (
    <Box width={"100%"} height={"100%"}>
      {renderProperPage()}
    </Box>
  );
};

export default UidLink;
